import React from 'react';

import { Image } from 'react-bootstrap';
import { Trans, useTranslation } from 'react-i18next';

import { Modal, ModalButton, ModalFooter } from 'components/shared/Modal';
import { IPendingCart } from 'models/cart/IPendingCart';

import './styles.scss';

interface IPaymentErrorModal {
    handleClose: () => void;
    show: boolean;
    error: boolean | string | IPendingCart;
}

export const PaymentErrorModal = ({handleClose, show, error}: IPaymentErrorModal) => {
    const {t} = useTranslation();

    return (
        <Modal show={show} onHide={handleClose}>
            <div className="d-flex flex-column justify-content-center align-items-center">
                <h5 className="font-weight-bold mt-5 mb-3">{t('payment.unsuccessful', 'Your Payment was Unsuccessful')}</h5>
                <Image
                    src="/assets/images/Error.svg"
                    alt={t('payment.errorInTransaction', 'Error in Transaction')}
                    className="ErrorModal__error-image"
                />
                <div className="ErrorModal__explainer-text-box mb-4">
                    <Trans i18nKey="payment.errorProcessingPaymentMessage">
                        We were unable to process your payment. Please ensure that the credit card details you have
                        entered are correct, and that there are sufficient funds available.
                    </Trans>
                </div>
                <div className="ErrorModal__explainer-text-box mb-4 font-weight-bold">
                    {error}
                </div>
            </div>
            <ModalFooter>
                <ModalButton className="border" variant="light" type="submit" onClick={() => handleClose()}>
                    {t('actions.tryAgain', 'Try Again')}
                </ModalButton>
            </ModalFooter>
        </Modal>
    );
};
